import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

export interface IStringsEditorConfig {
    title: string;
    values: Array<string>,
    allowAppend: boolean;
    allowEditing: boolean;
    allowDeleting: boolean;
}


@Component
export default class StringsEditor extends Vue {

    @Prop()
    value: IStringsEditorConfig;

    closeDialog(result: boolean) {
        if (result)
            this.$emit("dialogClosed", "ok", this.value.values);
        else
            this.$emit("dialogClosed", "cancel");

    }

    addRow() {
        this.value.values.push("");
    }

    removeRow(index: number) {
        this.value.values.splice(index, 1);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/strings-editor/strings-editor.ts